import { AvatarOrderingForm } from '@/components/backoffice/AvatarOrderingForm';
import { AvatarStudioOrderingForm } from '@/components/backoffice/AvatarStudioOrderingForm';
import { OrganizationForm } from '@/components/backoffice/OrganizationForm';
import { PresenterIdleVideoForm } from '@/components/backoffice/PresenterIdleVideoForm';
import { PresenterOwnerForm } from '@/components/backoffice/PresenterOwnerForm';
import { VoiceManagementForm } from '@/components/backoffice/VoiceManagementForm';
import { useFlag } from '@/services/featureFlags';
import { AppRoutes } from '@/utils/types';
import { Container, Grid, Paper, Typography, styled } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const StyledContainer = styled(Container)(({ theme }) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'box-shadow 0.3s ease-in-out',
    '&:hover': {
        boxShadow: theme.shadows[4],
    },
}));

export const BackofficePage = () => {
    const backofficeEnabled = useFlag('backoffice_is_enabled', false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!backofficeEnabled) {
            navigate(AppRoutes.Home);
        }
    }, []);

    return (
        <StyledContainer maxWidth="lg">
            <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 4, color: 'primary.main' }}>
                Backoffice
            </Typography>

            <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                    <StyledPaper elevation={2}>
                        <Typography
                            variant="h5"
                            component="h2"
                            sx={{ fontWeight: 600, mb: 3, borderBottom: '2px solid', borderColor: 'primary.main', pb: 1 }}>
                            Organization Management
                        </Typography>
                        <OrganizationForm />
                    </StyledPaper>
                </Grid>
                <Grid item xs={12} md={6}>
                    <StyledPaper elevation={2}>
                        <Typography
                            variant="h5"
                            component="h2"
                            sx={{ fontWeight: 600, mb: 3, borderBottom: '2px solid', borderColor: 'primary.main', pb: 1 }}>
                            V2 Presenter Management
                        </Typography>
                        <PresenterOwnerForm />
                        <PresenterIdleVideoForm />
                    </StyledPaper>
                </Grid>
                <Grid item xs={12}>
                    <StyledPaper elevation={2}>
                        <Typography
                            variant="h5"
                            component="h2"
                            sx={{ fontWeight: 600, mb: 3, borderBottom: '2px solid', borderColor: 'primary.main', pb: 1 }}>
                            Voice Management
                        </Typography>
                        <VoiceManagementForm />
                    </StyledPaper>
                </Grid>
                <Grid item xs={12}>
                    <StyledPaper elevation={2}>
                        <Typography
                            variant="h5"
                            component="h2"
                            sx={{ fontWeight: 600, mb: 3, borderBottom: '2px solid', borderColor: 'primary.main', pb: 1 }}>
                            Agents Avatars Ordering
                        </Typography>
                        <AvatarOrderingForm />
                    </StyledPaper>
                </Grid>
                <Grid item xs={12}>
                    <StyledPaper elevation={2}>
                        <Typography
                            variant="h5"
                            component="h2"
                            sx={{ fontWeight: 600, mb: 3, borderBottom: '2px solid', borderColor: 'primary.main', pb: 1 }}>
                            Avatars Ordering for Studio
                        </Typography>
                        <AvatarStudioOrderingForm />
                    </StyledPaper>
                </Grid>
            </Grid>
        </StyledContainer>
    );
};
